import { Anchor, Card, Image, Stack, Text } from '@mantine/core'

import screenplayProGif from '#assets/images/whats-new/screenplay-pro.gif'

import { DashboardCardGroup } from './DashboardCardGroup'
import { DashboardCardShell } from './DashboardCardShell'

import styles from './WhatsNewCard.module.css'

export const WhatsNewCard = () => (
  <DashboardCardShell>
    <Text fw="bold">What&apos;s New in Scripto?</Text>
    <Card classNames={styles}>
      <DashboardCardGroup gap={20} wrap="nowrap">
        <Image src={screenplayProGif} mah={204} maw={279} fit="contain" />
        <Stack gap="sm" miw={100}>
          <Text fw="bold">New screenplay features 🎉</Text>
          <Text>
            Anyone can now track changes, add title pages, and automatically
            add&nbsp;
            <Anchor
              href="https://help.scripto.live/en/articles/11465606-mores-and-continueds-screenplay-only"
              target="_blank"
            >
              scene continueds, character continueds, and dialogue continueds
            </Anchor>
            .
          </Text>
          <Text>
            And with a paid plan, you can now access locked pages and colored
            revisions.
          </Text>
        </Stack>
      </DashboardCardGroup>
    </Card>
  </DashboardCardShell>
)
